import { useLang } from "@/lib/i18n";
import { Globe } from "lucide-react";

/**
 * Compact ES/EN switch. `variant`:
 *  - "dark"  → for white/light backgrounds (default)
 *  - "light" → for dark backgrounds (e.g. black header)
 */
export default function LanguageSwitcher({ className = "", variant = "dark" }) {
  const { lang, setLang } = useLang();
  const isDark = variant === "dark";
  const base = isDark
    ? "border-black text-black"
    : "border-white text-white";
  const active = isDark ? "bg-black text-white" : "bg-white text-black";
  const inactive = isDark ? "hover:bg-black/10" : "hover:bg-white/10";

  return (
    <div
      className={`inline-flex items-center border-2 ${base} ${className}`}
      data-testid="lang-switcher"
      aria-label="Language switcher"
    >
      <Globe size={12} className="mx-1.5" />
      <button
        type="button"
        onClick={() => setLang("es")}
        data-testid="lang-es"
        className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest transition-colors ${
          lang === "es" ? active : inactive
        }`}
      >
        ES
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest transition-colors ${
          lang === "en" ? active : inactive
        }`}
      >
        EN
      </button>
    </div>
  );
}
